import React from 'react'
import './DescrptionBox.css'
const DescrptionBox = () => {
  return (
    <div className='descrptionbox'>
      <div className="descrptionbox-navigator">
        <div className="descrptionbox-nav-box">Descrption</div>
        <div className="descrptionbox-nav-box fade">Reviews (122)</div>
      </div>
      <div className="descrptionbox-description">
        <p>An e-commerce website is a site that allows people to buy and sell products and services over the internet. Some examples of e-commerce websites include digital marketplaces, online retail stores, and auction sites. 
        </p>
        <p>
        Ecommerce, short for electronic commerce, refers to the buying and selling of goods and services over the internet. It involves a transaction between two parties, usually a business and a consumer, where the payment and delivery of products or services are conducted online.

        </p>
      </div>
    </div>
  )
}

export default DescrptionBox
